import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e671dce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "favorite-products" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-angle-right icon-right",
  style: {"margin-left":"6px"}
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "product-list"
}
const _hoisted_6 = {
  key: 1,
  class: "empty-content"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-empty" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/icon_empty.png" })
], -1))

import { onMounted, reactive, ref } from 'vue'
import { t } from '@/plugins/i18n'
import { getFavoriteGoodsList } from '@/apis/goods'
import GoodsItem from '@/components/common/GoodsItem.vue'
import { useRtfix } from '@/store'
import { bury } from '@/util/useBury'
import { TaEvent, taTrack } from '@/util/buryingPoint'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onMounted(() => {
  getList()
})
const loading = ref(false)
/** 收藏的商品 */
const productList = ref([])
const pageInfo: any = reactive({
  pageNum: 1,
  pageSize: 20
})

// 获取列表
const getList = () => {
  loading.value = true
  getFavoriteGoodsList(pageInfo).then((res: any) => {
    if (res.code === '0') {
      productList.value = res.data.records
    }
  }).finally(() => {
    loading.value = false
  })
}

// 商品取消收藏
const cancelCollect = (productCode: string) => {
  const index = productList.value.findIndex((item: any) => item.productCode === productCode)
  productList.value.splice(index, 1)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('我收藏的商品')), 1),
      (productList.value?.length)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _unref(useRtfix)('CollectProduct'),
            class: "show-more"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('查看更多')) + " ", 1),
              _hoisted_4
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    (productList.value?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "product-item",
              key: item.productCode
            }, [
              _createVNode(GoodsItem, {
                item: item,
                showChannel: 2,
                imgHeight: "180px",
                nameSize: "14px",
                priceSize: "16px",
                showSellNum: false,
                onCancelCollect: cancelCollect,
                onJump: _cache[0] || (_cache[0] = ($event: any) => (_unref(bury)('Workbench_{plat}_Click_FavorProduct'))),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (
                       _unref(taTrack)({
                            event: _unref(TaEvent).BTN_CLICK,
                            value: {
                                position: 'collect_product'
                            }
                        })
                    ))
              }, null, 8, ["item"])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString(_unref(t)('暂无数据')), 1)
        ]))
  ]))
}
}

})